import useClick from './useClick';

export default useClick;
